import resume from '../assets/pdf/resume.pdf'
import avatar from '../assets/png/avatar.jpg'

export const headerData = {
    name: 'Marko Milen',
    title: "Full Stack and Blockchain Developer",
    desciption:"Full Stack and Blockchain Developer with 5+ years of experience designing, developing and implementing secure and scalable decentralized applications (dApps) and smart contracts. Proficient in Solidity, Ethereum, and Rust, with a strong foundation in cryptography, consensus algorithms, and Web3protocols. Passionate about decentralized finance (DeFi), tokenization, and improving blockchain scalability and user experience",
    image: avatar,
    resumePdf: resume
}
